import { logger } from 'services';

// Ideally watchdog should have handle and recover from all these errors but we've seen that
// watchdog recovery is not optimal, and doc is not actually working properly even after recovery.
const errorStrings = [
  'sessions-unregister-not-exist',
  "cloud-services-internal-error: Connection hasn't been authenticated in a period of time",
  'realtimecollaborationclient-handleserverresponse',
  'cloudservices-reconnection-error',
  'cloud-services-internal-error: Invalid token',
  'cloud-services-internal-error: Collaborative Editing Service is not connected.',
  'cloud-services-internal-error: Cannot reconnect to already connected service',
  'cloud-services-internal-error: websocket error',
  'cyclic object value',
];

export const checkforFatalCKECollaborationPluginError = (
  eventMessage: string,
  onConfirm?: () => void,
): void => {
  const isAFatalCKECollaborationPluginError = errorStrings.some((errorString) =>
    eventMessage.includes(errorString),
  );

  logger.info(
    `Checking an error for CKE crashes. Message: ${eventMessage} ${{
      isAFatalCKECollaborationPluginError,
    }}`,
  );

  if (isAFatalCKECollaborationPluginError) {
    logger.info('A fatal CKEditor collaboration plugin error detected.');
    if (onConfirm) {
      onConfirm();
    }
  }
};

const reloadPage = () => {
  logger.info('Reloading the page');

  window.location.reload();
};

export const handleCKErrors = (event: ErrorEvent): void => {
  checkforFatalCKECollaborationPluginError(event?.message ?? '', reloadPage);
};
